import '../../assets/css/binstock.css';
import BinStockSection from "./BinStockSection";

export default function BinStock() {
    return (
        <>
            <div className="main-container-binstock">
                <BinStockSection />
            </div>
        </>
    );
}